<!-- src/components/modal/backup-modal.vue -->
<template>
  <!-- Generate Backup Modal -->
  <div class="modal fade" id="generate_backup">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Generate {{ typeLabel }} Backup</h4>
          <button
            type="button"
            class="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x"></i>
          </button>
        </div>
        <form @submit.prevent="submitForm">
          <div class="modal-body">
            <p class="text-dark fw-medium mb-0">
              Are you sure you want to generate
              <span class="text-lowercase">{{ typeLabel }}</span> backup?
            </p>
          </div>
          <div class="modal-footer">
            <a
              href="javascript:void(0);"
              class="btn btn-light me-2"
              data-bs-dismiss="modal"
            >
              Cancel
            </a>
            <button
              type="submit"
              class="btn btn-primary"
              :disabled="generating"
            >
              <span v-if="generating">
                <span
                  class="spinner-border spinner-border-sm me-1"
                  role="status"
                  aria-hidden="true"
                ></span>
                Generating...
              </span>
              <span v-else>Generate</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Generate Backup -->

  <!-- Delete Modal -->
  <div class="modal fade" id="delete_modal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body text-center">
          <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
            <i class="ti ti-trash-x fs-36"></i>
          </span>
          <h4 class="mb-1">Confirm Delete</h4>
          <p class="mb-3">
            You want to delete the selected backup item(s). This cannot be
            undone once you delete.
          </p>
          <div class="d-flex justify-content-center">
            <a
              href="javascript:void(0);"
              class="btn btn-light me-3"
              data-bs-dismiss="modal"
            >
              Cancel
            </a>
            <button
              type="button"
              class="btn btn-danger"
              :disabled="loading"
              @click="handleConfirmDelete"
            >
              <span v-if="loading">
                <span
                  class="spinner-border spinner-border-sm me-1"
                  role="status"
                  aria-hidden="true"
                ></span>
                Deleting...
              </span>
              <span v-else>Yes, Delete</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete Modal -->
</template>

<script setup>
import { computed } from "vue";
import { useBackupStore } from "@/stores/settings/backup.store";

const props = defineProps({
  // From parent backup-settings.vue
  activeTab: {
    type: String,
    default: "system", // default to system for clarity
  },
});

const backupStore = useBackupStore();

const generating = computed(() => backupStore.generating);
const loading = computed(() => backupStore.loading);

// map activeTab to friendly label and type
const currentType = computed(() =>
  props.activeTab === "system" ? "system" : "database"
);
const typeLabel = computed(() =>
  currentType.value === "system" ? "System" : "Database"
);

function closeModal(id) {
  const el = document.getElementById(id);
  if (!el) return;

  // Use Bootstrap's JS API if available
  const win = window;
  const bootstrap = win.bootstrap;
  if (bootstrap?.Modal) {
    let instance = bootstrap.Modal.getInstance(el);
    if (!instance) {
      instance = new bootstrap.Modal(el);
    }
    instance.hide();
  } else {
    // Fallback: just remove classes
    el.classList.remove("show");
    el.style.display = "none";
  }

  // Hard cleanup of stray backdrops/body state
  document
    .querySelectorAll(".modal-backdrop")
    .forEach((backdrop) => backdrop.remove());
  document.body.classList.remove("modal-open");
  document.body.style.removeProperty("padding-right");
}

async function submitForm() {
  try {
    await backupStore.generate(currentType.value);
    // Close modal + clean backdrops on success
    closeModal("generate_backup");
  } catch (e) {
    // toast already handled in store; keep modal open on failure
  }
}

async function handleConfirmDelete() {
  try {
    await backupStore.confirmPendingDelete();
    closeModal("delete_modal");
  } catch (e) {
    // toast already handled in store; keep modal open on failure
  }
}
</script>
